import { load } from '@arkadium/jarvis/dist/prebid';
import { getGeo } from '@arkadium/jarvis/dist/v2';

import { JarvisResponse } from './config-service';

type GeoResponse = ReturnType<typeof getGeo>;

const TIMEOUT = 2500;

function getEids() {
  let id = (document.cookie.match(/ai_user=(.+?);/) || [])[1];
  if (!id) {
    try {
      id = localStorage.getItem('adsid') || '';
      if (!id) {
        id = btoa(Math.random().toString());
        localStorage.setItem('adsid', id);
      }
    } catch (e) {
      id = 'anon';
    }
  }
  return { source: 'arkadium.com', uids: [{ atype: 1, ext: { stype: 'ppuid' }, id }] };
}

export class PrebidService {
  protected pb: any;
  protected bids: any[];
  protected geoLoaded: GeoResponse;
  protected prebidLoaded: Promise<any>;
  protected prebidConfigured: Promise<any>;
  protected schain: any;

  constructor(config: JarvisResponse, protected dfpNetworkCode: string, protected inventoryCode: string) {
    this.bids = config.config.bids;
    this.geoLoaded = getGeo();
    this.prebidLoaded = this.prebidConfigured = load(config);
  }

  public async addAdUnit(adUnit: any) {
    const slotName = `/${this.dfpNetworkCode}/${this.inventoryCode}/${adUnit.id}`;
    const prebid = await this.prebidConfigured;
    const geo = await this.geoLoaded;
    const bids = this.applyGeoFilter(geo, this.bids);

    prebid.addAdUnits({
      code: adUnit.id,
      bids: bids.map(({ bidder, params }) => ({ bidder, params })),
      sizes: adUnit.size,
      mediaTypes: {
        banner: { sizes: adUnit.size },
      },
      ortb2Imp: {
        ext: {
          data: {
            adserver: {
              adslot: slotName,
              name: "gam"
            },
            pbadslot: slotName
          },
          gpid: slotName
        },
      },
    });
  }

  public async removeAdUnit(adUnit: any) {
    const prebid = await this.prebidConfigured;
    prebid.removeAdUnit(adUnit.id);
  }

  public requestBids(adUnitCodes: any[]) {
    return new Promise(async (resolve, reject) => {
      const timeout = setTimeout(resolve, TIMEOUT);
      await this.geoLoaded;
      const prebid = await this.prebidConfigured;
      prebid.requestBids({
        adUnitCodes,
        timeout: TIMEOUT,
        bidsBackHandler: (bids: any[]) => {
          clearTimeout(timeout);
          window.googletag.cmd.push(() => {
            prebid.setTargetingForGPTAsync();
            resolve(bids);
          });
        }
      });
    });
  }

  protected applyGeoFilter(geo: Awaited<GeoResponse>, bids: any[]) {
    return bids.filter(b => !b.geo || new RegExp(b.geo).test(geo.country_code));
  }
}
